/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Debug_Info_Page_HeadingInputs */

const en_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile Linking Debugging Information`)
};

const id_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informasi Debugging Tautan Seluler`)
};

const ms_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maklumat Penyahpepijatan Pemautan Mudah Alih`)
};

const ca_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informació sobre la depuració de dispositius enllaçats`)
};

const cs_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informace o ladění propojení mobilních zařízení`)
};

const da_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oplysninger om fejlfinding af mobillinking`)
};

const de_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informationen zur Fehlersuche bei mobilen Verknüpfungen`)
};

const et_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobiilse linkimise silumise teave`)
};

const es_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información sobre depuración de enlaces móviles`)
};

const fr_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations de débogage`)
};

const hr_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacije o rješavanju problema pri mobilnom povezivanju`)
};

const it_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni di debug link mobile`)
};

const lv_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobilās ierīces piesaistīšanas atkļūdošanas informācija`)
};

const lt_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobiliojo saistymo derinimo informacija`)
};

const hu_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil hivatkozás hibakeresési adatai`)
};

const nl_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foutopsporingsinformatie over mobiele koppeling`)
};

const nb_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feilsøking for mobiltilkobling`)
};

const pl_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacje o debugowaniu połączeń mobilnych`)
};

const pt_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações de depuração da plataforma de Mobile Linking`)
};

const ro_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informații despre depanarea conexiunilor mobile`)
};

const sk_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informácie o ladení mobilného prepojenia`)
};

const sl_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacije o odpravljanju napak pri mobilnem povezovanju`)
};

const fi_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobiiliyhteyden viankorjaustiedot`)
};

const sv_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information om felsökning av mobila länkar`)
};

const vi_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin gỡ lỗi kết nối di động`)
};

const tr_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil Bağlantı Hata Ayıklama Bilgileri`)
};

const el_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πληροφορίες εντοπισμού σφαλμάτων σύνδεσης κινητών τηλεφώνων`)
};

const bg_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация за дебъгинг при мобилно свързване`)
};

const ru_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация по отладке мобильных связей`)
};

const sr_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информације о решавању проблема за повезивање мобилног уређаја`)
};

const uk_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Інформація для налагодження мобільного підключення`)
};

const ka_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მობილური კავშირის გამართვის ინფორმაცია`)
};

const hi_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मोबाइल लिंकिंग डिबगिंग इनफार्मेशन`)
};

const th_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อมูลการดีบักการเชื่อมโยงแบบเคลื่อนที่`)
};

const ko_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모바일 연동 디버깅 정보`)
};

const zh_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移动链接调试信息`)
};

const zh_tw_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行動連結除錯資訊`)
};

const ja_debug_info_page_heading = /** @type {(inputs: Debug_Info_Page_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モバイル連携デバッグ情報`)
};

/**
* | output |
* | --- |
* | "Mobile Linking Debugging Information" |
*
* @param {Debug_Info_Page_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const debug_info_page_heading = /** @type {((inputs?: Debug_Info_Page_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Debug_Info_Page_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_debug_info_page_heading(inputs)
	if (locale === "ms") return ms_debug_info_page_heading(inputs)
	if (locale === "ca") return ca_debug_info_page_heading(inputs)
	if (locale === "cs") return cs_debug_info_page_heading(inputs)
	if (locale === "da") return da_debug_info_page_heading(inputs)
	if (locale === "de") return de_debug_info_page_heading(inputs)
	if (locale === "et") return et_debug_info_page_heading(inputs)
	if (locale === "es") return es_debug_info_page_heading(inputs)
	if (locale === "fr") return fr_debug_info_page_heading(inputs)
	if (locale === "hr") return hr_debug_info_page_heading(inputs)
	if (locale === "it") return it_debug_info_page_heading(inputs)
	if (locale === "lv") return lv_debug_info_page_heading(inputs)
	if (locale === "lt") return lt_debug_info_page_heading(inputs)
	if (locale === "hu") return hu_debug_info_page_heading(inputs)
	if (locale === "nl") return nl_debug_info_page_heading(inputs)
	if (locale === "nb") return nb_debug_info_page_heading(inputs)
	if (locale === "pl") return pl_debug_info_page_heading(inputs)
	if (locale === "pt") return pt_debug_info_page_heading(inputs)
	if (locale === "ro") return ro_debug_info_page_heading(inputs)
	if (locale === "sk") return sk_debug_info_page_heading(inputs)
	if (locale === "sl") return sl_debug_info_page_heading(inputs)
	if (locale === "fi") return fi_debug_info_page_heading(inputs)
	if (locale === "sv") return sv_debug_info_page_heading(inputs)
	if (locale === "vi") return vi_debug_info_page_heading(inputs)
	if (locale === "tr") return tr_debug_info_page_heading(inputs)
	if (locale === "el") return el_debug_info_page_heading(inputs)
	if (locale === "bg") return bg_debug_info_page_heading(inputs)
	if (locale === "ru") return ru_debug_info_page_heading(inputs)
	if (locale === "sr") return sr_debug_info_page_heading(inputs)
	if (locale === "uk") return uk_debug_info_page_heading(inputs)
	if (locale === "ka") return ka_debug_info_page_heading(inputs)
	if (locale === "hi") return hi_debug_info_page_heading(inputs)
	if (locale === "th") return th_debug_info_page_heading(inputs)
	if (locale === "ko") return ko_debug_info_page_heading(inputs)
	if (locale === "zh") return zh_debug_info_page_heading(inputs)
	if (locale === "zh-tw") return zh_tw_debug_info_page_heading(inputs)
	if (locale === "ja") return ja_debug_info_page_heading(inputs)
	return en_debug_info_page_heading(inputs)
});